"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _curry = _interopRequireDefault(require("curry"));
const find = (0, _curry.default)((fn, data) => {
  if (!data) return;
  if (Array.isArray(data)) return data.find(fn);
  const objectKeys = Object.keys(data);
  for (let key of objectKeys) {
    if (fn(data[key], key, data)) {
      return {
        [key]: data[key]
      };
    }
  }
});
var _default = exports.default = find;